import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href", "to", "target", "rel", "referrerpolicy", "download"],
  _excluded2 = ["as", "forwardedAs", "type", "isActive", "isDisabled", "onClick", "className", "role", "tabIndex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, useCallback } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import 'focus-visible';
import { useTabIndexContext } from 'components/TabIndexContext';
import { jsx as _jsx } from "react/jsx-runtime";
var Clickable = styled.button.withConfig({
  displayName: "ButtonCore__Clickable",
  componentId: "sc-z48ctd-0"
})(["display:inline-block;margin:0;padding:0;vertical-align:middle;font:inherit;text-decoration:none;text-align:inherit;color:inherit;background-color:transparent;border:none;border-radius:0;appearance:none;&:not(.is-disabled){cursor:pointer;}&:focus:not(.focus-visible),&:focus:not([data-focus-visible-added]){outline:none;}&.focus-visible,&[data-focus-visible-added]{outline:3px solid currentColor;outline-offset:3px;}&::-moz-focus-inner{padding:0;border:0;}"]);
function filterLinkProps(props, isDisabled) {
  if (isDisabled) {
    var href = props.href,
      to = props.to,
      target = props.target,
      rel = props.rel,
      referrerpolicy = props.referrerpolicy,
      download = props.download,
      remainingProps = _objectWithoutProperties(props, _excluded);
    return remainingProps;
  }
  return props;
}
export var ButtonCore = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    forwardedAs = _ref.forwardedAs,
    type = _ref.type,
    isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    onClick = _ref.onClick,
    className = _ref.className,
    role = _ref.role,
    tabIndex = _ref.tabIndex,
    otherProps = _objectWithoutProperties(_ref, _excluded2);
  var tabIndexContext = useTabIndexContext();
  var baseComponent = as || forwardedAs;
  var isButton = baseComponent === 'button' || !baseComponent && !forwardedAs;
  /**
   * There's no such thing as a disabled anchor tag in HTML,
   * so if one should appear "disabled", we render it as a `span`
   */
  var isDisabledLink = !isButton && !role && isDisabled || false;
  var Component = isDisabledLink && 'span' || baseComponent || 'button';
  var defaultType = !type && isButton ? 'button' : type;
  var classes = classNames(className, {
    'is-active': isActive,
    'is-disabled': isDisabled
  });
  var click = useCallback(function (event) {
    if (isDisabled) {
      event.stopPropagation();
      event.preventDefault();
    } else if (onClick) {
      onClick(event);
    }
  }, [isDisabled, onClick]);
  if (Component === 'a' && !(otherProps !== null && otherProps !== void 0 && otherProps.href)) {
    // eslint-disable-next-line no-console
    console.warn('Buttoncore: The `href` prop is required for `a`. Please provide a href or use a different component');
  }
  return (
    /*#__PURE__*/
    /*
     Warning!!! `Clickable` is currently not being properly typechecked.
     Comment out `otherProps` and `as` when making changes to check types 
    */
    _jsx(Clickable, _objectSpread(_objectSpread({}, filterLinkProps(otherProps, isDisabledLink)), {}, {
      as: Component,
      ref: ref,
      type: defaultType,
      role: role,
      "aria-disabled": (isButton || !!role) && isDisabled ? 'true' : undefined,
      "aria-pressed": isButton && isActive ? 'true' : isActive === false ? 'false' : undefined,
      tabIndex: tabIndexContext !== null && tabIndexContext !== void 0 ? tabIndexContext : tabIndex,
      onClick: click,
      className: classes
    }))
  );
});
ButtonCore.displayName = 'ButtonCore';
export default ButtonCore;